import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { MessageActionModalComponent } from '../common/message-action-modal/message-action-modal.component';
import { ThMessageModalComponent } from '../treasure-hunt/th-message-modal/th-message-modal.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-action-list',
    templateUrl: './action-list.component.html',
    styleUrls: ['./action-list.component.scss'],
    standalone: false
})
export class ActionListComponent  implements OnInit {

  addDuplicateFindingAction:any =[];
  addOldFindingAction:any = [];
  hunt_theme:any;
  newActionsCount : any = 0;
  existinAddedActionCount : any =0;
  constructor(private modalController: ModalController,private translate: TranslateService) { }

  ngOnInit() {
    console.log('in modal',this.addDuplicateFindingAction,this.addOldFindingAction);
    
  }



   async maxActionsAlert(title, description) {
      const alert = await this.modalController.create({
        component: MessageActionModalComponent,
        componentProps: {
          title: '',
          component: ThMessageModalComponent,
          componentProps: {
            iconType: 'lottie',
            iconSrc: 'assets/img/treasure_hunt/animation/Alert.json',
            title: this.translate.instant(title),
            message: this.translate.instant(description),
            highlightText: '',
            showPrompt: false,
            prompt: '',
            buttons: [
              {
                text: this.translate.instant('TREASURE_HUNT.OKAY'),
                cssClass: 'btn-filled',
                handler: (modalCtrl, data) => modalCtrl.dismiss({ status: true, ...data }),
              }
            ],
          },
        },
        cssClass: 'message-action-sheet-modal',
        showBackdrop: true,
        handle: true,
        backdropDismiss: false,
        handleBehavior: 'none',
      });
      alert.onDidDismiss().then(async (res: any) => {
        if (res.data && res.data.status) {
        }
      });
  
      return await alert.present();
    }

  async addOldAction(actions:any,event:any,i:any){
    const isChecking = !!event?.detail?.checked;
    const existingIndex = this.addOldFindingAction.indexOf(actions);

    if (isChecking) {
      const nextTotal = this.newActionsCount + this.checkTotalAdded();
      if (nextTotal >= 3) {
        if (event && event.detail) {
          event.detail.checked = false;
        }
        if (event && event.target) {
          (event.target as HTMLInputElement).checked = false;
        }
        if (this.addDuplicateFindingAction && this.addDuplicateFindingAction[i]) {
          this.addDuplicateFindingAction[i].selected = false;
        }
        if (actions && actions.selected !== undefined) {
          actions.selected = false;
        }
        this.maxActionsAlert("Max 3 actions per finding",'You can select at most 3 actions.' );
        return;
      }
      if (existingIndex === -1) {
        this.addOldFindingAction.push(actions);
      }
      if (this.addDuplicateFindingAction && this.addDuplicateFindingAction[i]) {
        this.addDuplicateFindingAction[i].selected = true;
      }
    } else {
      if (existingIndex > -1) {
        this.addOldFindingAction.splice(existingIndex, 1);
      }
      if (this.addDuplicateFindingAction && this.addDuplicateFindingAction[i]) {
        this.addDuplicateFindingAction[i].selected = false;
      }
      if (actions && actions.selected !== undefined) {
        actions.selected = false;
      }
    }
    console.log(this.addDuplicateFindingAction);
  }

  selectAction(){
    this.modalController.dismiss({'result':'ok',actionList:this.addDuplicateFindingAction});
  }
  addActionforFinding(){
    const nextTotal = this.newActionsCount + this.checkTotalAdded() + this.existinAddedActionCount; 
      if (nextTotal >= 3) {
        this.maxActionsAlert("Max 3 actions per finding",'You can select at most 3 actions.' );
      }else{
          this.modalController.dismiss({'result':'open-action'});
      }
  }

  dismiss(){
      this.modalController.dismiss({'result':'closed'});
  }

  checkTotalAdded(){
   return   (this.addDuplicateFindingAction.filter((x) => x.selected == true)).length;
  }
}
